import React from 'react';
import { Reveal, RevealItem } from './Reveal';
export const FeaturesSection = () => {
  return <section className="pt-16 md:pt-24 pb-12 md:pb-20 px-[5vw] bg-white relative overflow-hidden" data-id="element-184">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-185">
        {/* Header */}
        <Reveal data-id="element-186">
          <div className="flex flex-col items-center text-center mb-12 md:mb-16" data-id="element-187">
            <span className="inline-block border border-gold/30 bg-gold-soft/30 text-ink font-bold text-[11px] md:text-xs tracking-[0.15em] uppercase px-3 py-1 rounded-full mb-6" data-id="element-188">
              TUDO EM UM LUGAR SÓ
            </span>
            <h2 className="font-serif font-bold text-[clamp(32px,5vw,48px)] tracking-[-0.02em] text-ink mb-6 leading-tight" data-id="element-189">
              O que tem dentro da{' '}
              <span className="text-rose italic" data-id="element-190">Aurora</span>
            </h2>
            <div className="w-12 h-1 bg-gold rounded-full mb-6" data-id="element-191"></div>
            <p className="text-[15px] md:text-[17px] text-ink-soft max-w-md" data-id="element-192">
              Feito pra caber na sua rotina, não pra te dar mais trabalho.
            </p>
          </div>
        </Reveal>

        {/* Cards */}
        <div className="flex flex-col gap-6 md:gap-8" data-id="element-193">
          {/* CARD 1 */}
          <Reveal delay={0.1} data-id="element-194">
            <div className="bg-white rounded-3xl border border-line shadow-sm overflow-hidden" data-id="element-195">
              <div className="p-6 md:p-8" data-id="element-196">
                <div className="mb-2" data-id="element-197">
                  <h3 className="font-serif font-bold text-xl md:text-2xl text-rose" data-id="element-198">
                    Pra precificar sem chutar
                  </h3>
                </div>
                <p className="text-ink-soft text-[14px] md:text-[15px] mb-6 md:mb-8" data-id="element-199">
                  O preço justo aparece sozinho, com tudo na conta.
                </p>

                <div className="space-y-4 md:space-y-5" data-id="element-200">
                  <RevealItem className="flex gap-3" data-id="element-201">
                    <span className="text-xl flex-shrink-0" data-id="element-202">🧮</span>
                    <p className="text-[14px] md:text-[15px] text-ink leading-snug pt-0.5" data-id="element-203">
                      <strong className="font-semibold" data-id="element-204">
                        Custo real de cada produto
                      </strong>{' '}
                      — material, embalagem, sua mão de obra e custos fixos,
                      tudo somado.
                    </p>
                  </RevealItem>
                  <div className="border-t border-line/50 ml-8" data-id="element-205"></div>
                  <RevealItem className="flex gap-3" data-id="element-206">
                    <span className="text-xl flex-shrink-0" data-id="element-207">⚡</span>
                    <p className="text-[14px] md:text-[15px] text-ink leading-snug pt-0.5" data-id="element-208">
                      <strong className="font-semibold" data-id="element-209">Preço na hora</strong> —
                      você escolhe a margem e o valor aparece enquanto digita.
                    </p>
                  </RevealItem>
                  <div className="border-t border-line/50 ml-8" data-id="element-210"></div>
                  <RevealItem className="flex gap-3" data-id="element-211">
                    <span className="text-xl flex-shrink-0" data-id="element-212">🔄</span>
                    <p className="text-[14px] md:text-[15px] text-ink leading-snug pt-0.5" data-id="element-213">
                      <strong className="font-semibold" data-id="element-214">
                        Recálculo automático
                      </strong>{' '}
                      — insumo subiu? Atualiza num lugar só e todos os produtos
                      se ajustam.
                    </p>
                  </RevealItem>
                  <div className="border-t border-line/50 ml-8" data-id="element-215"></div>
                  <RevealItem className="flex gap-3" data-id="element-216">
                    <span className="text-xl flex-shrink-0" data-id="element-217">📈</span>
                    <p className="text-[14px] md:text-[15px] text-ink leading-snug pt-0.5" data-id="element-218">
                      <strong className="font-semibold" data-id="element-219">
                        Margem sob controle
                      </strong>{' '}
                      — você vê na hora se um produto está te dando lucro ou
                      prejuízo.
                    </p>
                  </RevealItem>
                </div>
              </div>

              {/* Objection Footer */}
              <div className="bg-[#F9F6F0] border-l-4 border-gold p-5 md:px-8 md:py-5 flex gap-3 items-start" data-id="element-220">
                <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-221">💬</span>
                <p className="text-[13px] md:text-[14px] text-ink-soft italic leading-relaxed" data-id="element-222">
                  Acha que vai dar trabalho cadastrar? Você faz isso uma vez só.
                  Em 15 minutos já tem seu primeiro produto precificado de
                  verdade.
                </p>
              </div>
            </div>
          </Reveal>

          {/* CARD 2 */}
          <Reveal delay={0.2} data-id="element-223">
            <div className="bg-white rounded-3xl border border-line shadow-sm overflow-hidden" data-id="element-224">
              <div className="p-6 md:p-8" data-id="element-225">
                <div className="mb-2" data-id="element-226">
                  <h3 className="font-serif font-bold text-xl md:text-2xl text-rose" data-id="element-227">
                    Pra organizar sem caderninho
                  </h3>
                </div>
                <p className="text-ink-soft text-[14px] md:text-[15px] mb-6 md:mb-8" data-id="element-228">
                  Cada encomenda no lugar certo, sem esquecer nenhuma.
                </p>

                <div className="space-y-4 md:space-y-5" data-id="element-229">
                  <RevealItem className="flex gap-3" data-id="element-230">
                    <span className="text-xl flex-shrink-0" data-id="element-231">📝</span>
                    <p className="text-[14px] md:text-[15px] text-ink leading-snug pt-0.5" data-id="element-232">
                      <strong className="font-semibold" data-id="element-233">
                        Pedidos organizados
                      </strong>{' '}
                      — cliente, o que pediu, forma de pagamento e data de
                      entrega.
                    </p>
                  </RevealItem>
                  <div className="border-t border-line/50 ml-8" data-id="element-234"></div>
                  <RevealItem className="flex gap-3" data-id="element-235">
                    <span className="text-xl flex-shrink-0" data-id="element-236">🔔</span>
                    <p className="text-[14px] md:text-[15px] text-ink leading-snug pt-0.5" data-id="element-237">
                      <strong className="font-semibold" data-id="element-238">Alerta de prazo</strong>{' '}
                      — a Aurora te avisa quando a entrega tá chegando.
                    </p>
                  </RevealItem>
                  <div className="border-t border-line/50 ml-8" data-id="element-239"></div>
                  <RevealItem className="flex gap-3" data-id="element-240">
                    <span className="text-xl flex-shrink-0" data-id="element-241">🔒</span>
                    <p className="text-[14px] md:text-[15px] text-ink leading-snug pt-0.5" data-id="element-242">
                      <strong className="font-semibold" data-id="element-243">
                        Preço travado no pedido
                      </strong>{' '}
                      — o valor combinado com a cliente fica guardado, mesmo se
                      você mudar o produto depois.
                    </p>
                  </RevealItem>
                  <div className="border-t border-line/50 ml-8" data-id="element-244"></div>
                  <RevealItem className="flex gap-3" data-id="element-245">
                    <span className="text-xl flex-shrink-0" data-id="element-246">🎁</span>
                    <p className="text-[14px] md:text-[15px] text-ink leading-snug pt-0.5" data-id="element-247">
                      <strong className="font-semibold" data-id="element-248">
                        Pacotes prontos pra vender
                      </strong>{' '}
                      — a economia da cliente já vem calculada, o argumento de
                      venda pronto.
                    </p>
                  </RevealItem>
                </div>
              </div>
            </div>
          </Reveal>

          {/* CARD 3 */}
          <Reveal delay={0.3} data-id="element-249">
            <div className="bg-white rounded-3xl border border-line shadow-sm overflow-hidden" data-id="element-250">
              <div className="p-6 md:p-8" data-id="element-251">
                <div className="mb-2" data-id="element-252">
                  <h3 className="font-serif font-bold text-xl md:text-2xl text-rose" data-id="element-253">
                    Pra enxergar com clareza
                  </h3>
                </div>
                <p className="text-ink-soft text-[14px] md:text-[15px] mb-6 md:mb-8" data-id="element-254">
                  O fim do "acho que tá dando certo".
                </p>

                <div className="space-y-4 md:space-y-5" data-id="element-255">
                  <RevealItem className="flex gap-3" data-id="element-256">
                    <span className="text-xl flex-shrink-0" data-id="element-257">💰</span>
                    <p className="text-[14px] md:text-[15px] text-ink leading-snug pt-0.5" data-id="element-258">
                      <strong className="font-semibold" data-id="element-259">Resumo do mês</strong> —
                      faturamento, lucro e margem na sua frente, sem planilha.
                    </p>
                  </RevealItem>
                  <div className="border-t border-line/50 ml-8" data-id="element-260"></div>
                  <RevealItem className="flex gap-3" data-id="element-261">
                    <span className="text-xl flex-shrink-0" data-id="element-262">🏆</span>
                    <p className="text-[14px] md:text-[15px] text-ink leading-snug pt-0.5" data-id="element-263">
                      <strong className="font-semibold" data-id="element-264">Produto campeão</strong>{' '}
                      — veja qual dá mais lucro e qual te puxa pra baixo.
                    </p>
                  </RevealItem>
                  <div className="border-t border-line/50 ml-8" data-id="element-265"></div>
                  <RevealItem className="flex gap-3" data-id="element-266">
                    <span className="text-xl flex-shrink-0" data-id="element-267">📑</span>
                    <p className="text-[14px] md:text-[15px] text-ink leading-snug pt-0.5" data-id="element-268">
                      <strong className="font-semibold" data-id="element-269">
                        Histórico de preços
                      </strong>{' '}
                      — acompanhe como cada preço mudou ao longo do tempo.
                    </p>
                  </RevealItem>
                  <div className="border-t border-line/50 ml-8" data-id="element-270"></div>
                  <RevealItem className="flex gap-3" data-id="element-271">
                    <span className="text-xl flex-shrink-0" data-id="element-272">📱</span>
                    <p className="text-[14px] md:text-[15px] text-ink leading-snug pt-0.5" data-id="element-273">
                      <strong className="font-semibold" data-id="element-274">Tudo no celular</strong>{' '}
                      — sem Excel, sem computador.
                    </p>
                  </RevealItem>
                </div>
              </div>

              {/* Objection Footer */}
              <div className="bg-[#F9F6F0] border-l-4 border-gold p-5 md:px-8 md:py-5 flex gap-3 items-start" data-id="element-275">
                <span className="text-lg flex-shrink-0 mt-0.5" data-id="element-276">💬</span>
                <p className="text-[13px] md:text-[14px] text-ink-soft italic leading-relaxed" data-id="element-277">
                  Não importa se você é ruim com tecnologia. Se você usa o
                  WhatsApp e posta no Instagram, você usa a Aurora. E se travar,
                  a nossa equipe te ajuda de pessoa pra pessoa.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
};